
export class Config {
  static APP_ENV = process.env.REACT_APP_ENV as 'dev' | 'beta' | 'prod';


  private static _getAPI() {
    // if (Config.APP_ENV === 'dev') return 'http://localhost:8080';
    // else if (Config.APP_ENV === 'beta') return 'https://rental-management-be-latest.onrender.com';
    // else 
  
//      return 'http://31.97.239.54:8080';
 return 'https://api.selvamrentalmanagement.space';
  // return 'http://localhost:8080';



  }

  private static _getFEURL() {

    // if (Config.APP_ENV === 'dev') return 'http://localhost:3000';
    // else if (Config.APP_ENV === 'beta') return 'https://reactjs-app-z9f0.onrender.com';
    // else 
    // return 'http://localhost:3000'
    //	return 'http://195.35.23.17:3000';
    return 'https://selvamrentalmanagement.space/';
  }
  static API = this._getAPI();

  static feUrl = this._getFEURL()
}
